export default __webpack_public_path__ + "static/media/logo.d91f924f.svg";